import React from "react";
import PropTypes from "prop-types";
import Base from "../Base";
import { Checkbox } from "antd";

@autobind
/**
 *
 */
export default class CheckBoxGroup extends Base {
  static propTypes = {
    ...Base.propTypes,
    children: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.node,
    ]),
    value: PropTypes.arrayOf([
      PropTypes.string,
    ]),
  };

  /**
   *
   * @return {XML}
   */
  get _component() {
    return <Checkbox.Group />;
  }
}
